import { z } from "zod"

export const BackofficePerformanceResponseDataSchema = z.object({
  avgDailyConversations: z.number(),
  avgMessagePerConversation: z.number(),
  avgEngageRate: z.number(),
  dailyCount: z.array(
    z.object({
      date: z
        .date()
        .transform((value) => (value ? value.toISOString() : null))
        .nullable(),
      reached: z.number(),
      engaged: z.number(),
    }),
  ),
})
